import {
  useEffect,
  useState,
} from 'react';
import {
  Edit3 as Edit3Icon,
  Lock,
  RefreshCcw,
  Trash2 as Trash2Icon,
  Unlock,
} from 'react-feather';
import moment from 'moment';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  useDispatch,
  useSelector,
} from 'react-redux';
import { OrderAction } from 'src/actions/order.action';
import {
  CONFIRM_TYPES,
  DEFAULT_ROW_PER_PAGE,
  ROW_PER_PAGE_OPTIONS,
} from 'src/utils/constants';
import { getOrderStatus } from 'src/utils/utils';
import ConfirmDialog from '../ConfirmDialog';
import {
  Box,
  Card,
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
  IconButton,
  Select as Select1,
  MenuItem,
  Button,
} from '@material-ui/core';

import { Helmet } from "react-helmet";

import { Dialog, DialogTitle, DialogContent, Button as Button1 } from "@mui/material";

import CreateEditDialog from './CreateEditDialog';

import numeral from 'numeral';

const OrderLookupDetail = ({ ...rest }) => {
  const dispatch = useDispatch()
  const [selectedOrderIds, setSelectedOrderIds] = useState([]);
  const [limit, setLimit] = useState(DEFAULT_ROW_PER_PAGE);
  const [page, setPage] = useState(0);
  const { items, total, filter } = useSelector(state => state.order);
  const [confirm, setConfirm] = useState(false);
  const [confirmType, setConfirmType] = useState("");
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [selected, setSelected] = useState({});
  const [open, setOpen] = useState(false);
  const { info, permissions, role } = useSelector(state => state.profile)

  const [openModalLichSuTrangThai, setOpenModalLichSuTrangThai] = useState(false);
  const [contentModalLichSuTrangThai, setContentModalLichSuTrangThai] = useState("");

  useEffect(() => {
    const payload = {
      ...filter,
      limit: limit,
      page: page,
    };
    dispatch(OrderAction.updateFilter(payload));
    dispatch(OrderAction.list())
  }, [page, limit])

  const handleSelectAll = (event) => {
    let newSelectedOrderIds;

    if (event.target.checked) {
      newSelectedOrderIds = items.map((order) => order.id);
    } else {
      newSelectedOrderIds = [];
    }

    setSelectedOrderIds(newSelectedOrderIds);
  };

  const handleSelectOne = (event, id) => {
    const selectedIndex = selectedOrderIds.indexOf(id);
    let newSelectedOrderIds = [];

    if (selectedIndex === -1) {
      newSelectedOrderIds = newSelectedOrderIds.concat(selectedOrderIds, id);
    } else if (selectedIndex === 0) {
      newSelectedOrderIds = newSelectedOrderIds.concat(selectedOrderIds.slice(1));
    } else if (selectedIndex === selectedOrderIds.length - 1) {
      newSelectedOrderIds = newSelectedOrderIds.concat(selectedOrderIds.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelectedOrderIds = newSelectedOrderIds.concat(
        selectedOrderIds.slice(0, selectedIndex),
        selectedOrderIds.slice(selectedIndex + 1)
      );
    }

    setSelectedOrderIds(newSelectedOrderIds);
  };

  const handleLimitChange = (event) => {
    setLimit(event.target.value);
    setPage(0);
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handleConfirmOpen = (type, order) => {
    setSelected(order);
    setConfirmType(type);
    if (confirmType === CONFIRM_TYPES.DELETE) {
      setTitle("Xoá bản ghi")
      setContent(`Xác nhận xoá bản ghi `)
    }
    setConfirm(true);
  };

  const onConfirm = () => {
    setConfirm(false);
    if (confirmType === CONFIRM_TYPES.DELETE) {
      dispatch(OrderAction.del(selected.id))
      return;
    }
  }

  const handleConfirmClose = () => {
    setConfirm(false);
  };

  const onSelected = (id) => {
    dispatch(OrderAction.findOne(id));
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const setColor = (value) => {
    if (value == 'da_thanh_toan') return 'green';
    else if (value == 'chua_thanh_toan') return 'red';
    else if (value == 'chua_giao') return 'red';
    else if (value == 'dang_van_chuyen') return 'orange';
    else if (value == 'giao_thanh_cong') return 'green';
    else if (value == 'don_hang_that_lac') return 'red';
    else if (value == 'xu_ly_thanh_cong') return 'green';
    else if (value == 'online') return 'green';
    else if (value == 'cod') return 'blue';
    else if (value == 'MOBIFONE') return 'green';
    else if (value == 'VINAPHONE') return 'blue';
    else if (value == 'VIETTEL') return 'red';
    else return 'black';
  };

  const setTrangThaiThuTien = async (id, value) => {
    dispatch(OrderAction.update(id, { 
      trang_thai: value,
    }))
  }

  return (<>
    <Helmet>
      <style>{`
          
      `}</style>
    </Helmet>

    <Dialog className='lich_su_trang_thai_modal' open={openModalLichSuTrangThai} onClose={() => setOpenModalLichSuTrangThai(false)}>
      <DialogTitle></DialogTitle>
      <DialogContent>
        {contentModalLichSuTrangThai && <div>
          {contentModalLichSuTrangThai.split('\n').map((line, index) => (<>
            {line && line != "" && <>
              <p key={index}>- <span dangerouslySetInnerHTML={{ __html: line }} ></span></p>
              <br></br>
            </>}
          </>))}
        </div>}
      </DialogContent>
      <Button onClick={() => setOpenModalLichSuTrangThai(false)}>Đóng</Button>
    </Dialog>

    <Card {...rest} style={{ width: "100%"}}>
      <PerfectScrollbar>
        <Box sx={{ minWidth: 1500 }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>
                  #
                </TableCell>
                <TableCell>
                  Loại sản phẩm
                </TableCell>
                <TableCell>
                  Tên KH
                </TableCell>
                <TableCell>
                  SĐT đặt hàng
                </TableCell>
                <TableCell>
                  Địa chỉ chi tiết
                </TableCell>
                <TableCell>
                  Phường/xã
                </TableCell>
                <TableCell>
                  Quận/huyện
                </TableCell>
                <TableCell>
                  Tỉnh/thành
                </TableCell>
                <TableCell>
                  ID đơn hàng
                </TableCell>
                <TableCell>
                  Mã SIM
                </TableCell>
                <TableCell>
                  SĐT / Tên SP
                </TableCell>
                <TableCell>
                  Loại thuê bao
                </TableCell>
                <TableCell>
                  Giá
                </TableCell>
                <TableCell>
                  Hình thức thanh toán
                </TableCell>
                <TableCell>
                  Phí
                </TableCell>
                <TableCell>
                  Thực thu
                </TableCell>
                <TableCell>
                  Trạng thái
                </TableCell>
                <TableCell>
                  Ghi chú
                </TableCell>
                <TableCell>
                  Thời điểm tạo đơn
                </TableCell>
                <TableCell>
                  Chức năng
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {items && Object.values(items).length > 0 && items.slice(page * limit, page * limit + limit).map((order, index) => (
                order ? <TableRow
                  hover
                  key={order.id}
                  selected={selectedOrderIds.indexOf(order.id) !== -1}
                >
                  <TableCell>
                    {page * limit + index + 1}
                  </TableCell>
                  <TableCell style={{fontWeight: 'bold'}}>
                    {order.product_type == "sim_so" && "Sim số"}
                    {order.product_type == "sim_data" && "Sim data"}
                    {order.product_type == "voucher" && "Voucher"}
                  </TableCell>
                  <TableCell>
                    {order.name}
                    {order.note && order.note != "" && <>
                      <br></br>
                      <br></br>
                      <span style={{color: 'red'}}>* {order.note}</span>
                    </>}
                  </TableCell>
                  <TableCell>
                    <span style={{color: 'blue', fontWeight: 'bold'}}>{order.phone}</span>
                  </TableCell>
                  <TableCell>
                    {order.address ? order.address : '-'}
                  </TableCell>
                  <TableCell>
                    {order.ward_name ? order.ward_name : '-'}
                  </TableCell>
                  <TableCell>
                    {order.district_name ? order.district_name : '-'}
                  </TableCell>
                  <TableCell>
                    {order.province_name ? order.province_name : '-'}
                  </TableCell>
                  <TableCell>
                    <span style={{color: 'purple', fontWeight: 'bold'}}>{order.id}</span>
                  </TableCell>
                  <TableCell>
                    <span style={{textTransform: "uppercase"}}>{order.ma_sim ? order.ma_sim : '-'}</span>
                  </TableCell>
                  <TableCell>
                    {order.product_type == "sim_so" && <>
                      <span style={{color: 'teal', fontWeight: 'bold'}}>{order.ordered_so_dien_thoai_co_dau_cham}</span>
                      {order.ordered_nha_mang && order.ordered_nha_mang != "" && <>
                        <br></br>
                        (<span style={{color: setColor(order.ordered_nha_mang)}}>{order.ordered_nha_mang}</span>)
                      </>}
                    </>}

                    {order.product_type == "sim_data" && <>
                      <span style={{color: 'teal', fontWeight: 'bold'}}>{order.ordered_name}</span>
                      <br></br>
                      (SL: <span style={{color: 'red', fontWeight: 'bold'}}>{numeral(order.quantity).format('0,0')}</span>)
                    </>}
                  </TableCell>
                  <TableCell>
                  <span style={{color: order.ordered_number_type == 1 ? 'green' : (order.ordered_number_type == 2 ? 'blue' : 'black'), fontWeight: 'normal'}}>{order.ordered_number_type == 1 ? 'TRẢ TRƯỚC' : (order.ordered_number_type == 2 ? 'TRẢ SAU' : '-')}</span>
                  </TableCell>
                  <TableCell>
                    {order.product_type == "sim_so" && <span style={{color: 'red', fontWeight: 'bold'}}>{numeral(Number(order.ordered_gia_khach_hang_khuyen_mai) > 0 && Number(order.ordered_gia_khach_hang_khuyen_mai) < Number(order.ordered_gia_khach_hang) ? order.ordered_gia_khach_hang_khuyen_mai : order.ordered_gia_khach_hang).format('0,0')}</span>}
                    {order.product_type == "sim_data" && <span style={{color: 'red', fontWeight: 'bold'}}>{numeral(Number(order.ordered_price_new) > 0 && Number(order.ordered_price_new) < Number(order.ordered_price) ? order.ordered_price_new : order.ordered_price).format('0,0')}</span>}
                  </TableCell>
                  <TableCell>
                    <span style={{color: setColor(order.payment_method)}}>{order.payment_method == 'online' ? 'Chuyển khoản' : 'COD'}</span>
                  </TableCell>
                  <TableCell>
                    {numeral(Number(order.phi)).format('0,0')}
                  </TableCell>
                  <TableCell>
                    {numeral(Number(order.thuc_thu)).format('0,0')}
                  </TableCell>
                  <TableCell>
                    <Select1 
                      style={{
                          fontSize: '14px',
                          width: '120px',
                          marginBottom: '15px',
                          color: setColor(order.trang_thai)
                        }}
                        variant="outlined"
                        value={order.trang_thai}
                        onChange={(e) =>
                          setTrangThaiThuTien(order.id, e.target.value)
                        }
                      >
                      <MenuItem
                        style={{ color: setColor('chua_giao') }}
                        value="chua_giao"
                      >
                        Chưa giao
                      </MenuItem>
                      <MenuItem
                        style={{ color: setColor('dang_van_chuyen') }}
                        value="dang_van_chuyen"
                      >
                        Đang vận chuyển
                      </MenuItem>
                      <MenuItem
                        style={{ color: setColor('giao_thanh_cong') }}
                        value="giao_thanh_cong"
                      >
                        Giao thành công
                      </MenuItem>
                      <MenuItem
                        style={{ color: setColor('don_hang_that_lac') }}
                        value="don_hang_that_lac"
                      >
                        Đơn hàng thất lạc
                      </MenuItem>
                      <MenuItem
                        style={{ color: setColor('xu_ly_thanh_cong') }}
                        value="xu_ly_thanh_cong"
                      >
                        Xử lý thành công
                      </MenuItem>
                    </Select1>
                    {order.lich_su_trang_thai && <Button
                      color="primary"
                      variant="contained"
                      onClick={(e) => { setContentModalLichSuTrangThai(order.lich_su_trang_thai ? order.lich_su_trang_thai : ''); setOpenModalLichSuTrangThai(true); }}
                      style={{ height: '20px', padding: 0, marginTop: 0, width: '80px', minWidth: '20px', marginLeft: '5px', color: 'purple', backgroundColor: 'transparent', fontWeight: 'normal', fontSize: 16, border: '1px solid transparent' }}
                      >
                      Xem lịch sử
                    </Button>}
                  </TableCell>
                  <TableCell>
                    {order.ghi_chu_don_hang ? order.ghi_chu_don_hang : '-'}
                  </TableCell>
                  <TableCell>
                    {moment(order.createdAt).format('DD-MM-YYYY HH:mm:ss')}
                  </TableCell>
                  <TableCell>
                    <IconButton aria-label="edit" onClick={() => onSelected(order.id)}>
                      <Edit3Icon color='green' />
                    </IconButton>
                    {(role.priority < 3) && <IconButton aria-label="delete" onClick={() => handleConfirmOpen(CONFIRM_TYPES.DELETE, order)}>
                      <Trash2Icon color='red' />
                    </IconButton>}
                  </TableCell>
                </TableRow> : null
              ))}
            </TableBody>
          </Table>
        </Box>
      </PerfectScrollbar>
      <TablePagination
        component="div"
        count={total}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleLimitChange}
        page={page}
        rowsPerPage={limit}
        rowsPerPageOptions={ROW_PER_PAGE_OPTIONS}
      />
      <CreateEditDialog open={open} handleClose={handleClose} type={"EDIT"} />
      <ConfirmDialog open={confirm} title={title} content={content || `Xác nhận xoá bản ghi `} highlight={selected.so_dien_thoai_co_dau_cham} handleClose={handleConfirmClose} handleConfirm={onConfirm} />
    </Card>
  </>);
};

export default OrderLookupDetail;
